export default __webpack_public_path__ + "static/media/pitching.79452964.svg";